import { useQuery } from "@tanstack/react-query";
import { backendService } from "../services/backend.service";
import type { NurseInShift } from "../utils/models";

export const useUserShifts = () =>
	useQuery<Record<string, NurseInShift[]>>({
		queryKey: ["userShifts"],
		queryFn: async () => {
			const response = await backendService.getUserShifts();
			return response.data;
		},
	});
